'use strict';
import { WorklistComponent } from '../worklist.component';

export class WorklistDuplicatePatientsManager {
  public worklist: WorklistComponent;
  public duplicatePatientName: string;
  public duplicatePatientId: string;
  public redirectUrl: string;
  public duplicatePatientRowData: any;
  public worklistType: string;

  constructor(worklist: WorklistComponent) {
    this.worklist = worklist;
  }

  execute(rowData: any) {
    if (rowData && rowData.data) {
      this.duplicatePatientName = rowData.data.name_0_text;
      this.duplicatePatientId = rowData.data.id;
      this.duplicatePatientRowData = rowData.data;
      this.redirectUrl = rowData.config.redirectUrl;
      this.worklist.showDuplicatePatientWarning = true;
    }
  }

  duplicatePatientProceedCallback() {
    // Being called when duplicated patients were found and user clicks on Proceed AND when no duplicated patients were found
    const self = this['callbackObject']; // This referes to the component that fires the callback

    if (self) {
      self.worklist.load = true;
      self.worklist.goToState(self.redirectUrl, { rowData: self.duplicatePatientRowData});
    }
  }

  duplicatePatientBackCallback() {
    // Being called when duplicated patients were found and user clicks on Back
    const self = this['callbackObject'];

    if (self) {
      self.duplicatePatientName = ''; // Need to clear patient name so change detection will work
      self.worklist.showDuplicatePatientWarning = false;
    }
  }
}
